import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';
import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {

    setTimeout(()=>{
document.title="Neck Swelling Surgery Delhi | Lump Removal & Gland Excision";
},500);

    
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Neck Swelling Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get safe and effective neck swelling surgery and treatment in Delhi, India. Expert ENT specialists offer advanced care for painless recovery and better health." />
            <meta name="keywords" content="Neck Swelling Surgery, Neck Swelling Treatment, Neck Swelling Surgery in Delhi, Neck Swelling Treatment in Delhi NCR, Best ENT Doctor for Neck Swelling, Neck Lump Surgery, Neck Mass Removal Surgery, Neck Swelling Causes and Treatment, Affordable Neck Swelling Surgery India" />
            <link rel="canonical" href="https://entdelhi.com/neck-swelling-surgery/" />
            <meta property="og:title" content="Neck Swelling Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get safe and effective neck swelling surgery and treatment in Delhi, India. Expert ENT specialists offer advanced care for painless recovery and better health." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
